var render = function render(_c,_vm){return _c('div',{staticClass:"ce-html"},[_c('html-parser',{attrs:{"content":_vm.props.bodytext}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }